import useApiFetch from 'src/app/hooks/useApiFetch';
import DataWrapperChildrenParams from 'src/app/interfaces/dataWrapperChildrenParams';
import DataWrapperProps from 'src/app/interfaces/dataWrapperProps';
import BaseFetchOptions from 'src/data/api/common/BaseFetchOptions';
import ApiResponseBody from 'src/data/api/responses/ApiResponseBody';
import ticketService, { TicketDownloadLinkResponse } from 'src/data/services/ticketService';

interface CreateTicketFileAccessLinkDataWrapperChildrenParams
    extends DataWrapperChildrenParams<ApiResponseBody<TicketDownloadLinkResponse>> {
    createTicketFileAccessLink: (
        ticketFileId: string
    ) => Promise<ApiResponseBody<TicketDownloadLinkResponse>>;
}

type FetchTicketsDataWrapperProps = DataWrapperProps<
    CreateTicketFileAccessLinkDataWrapperChildrenParams,
    ApiResponseBody<TicketDownloadLinkResponse>
> &
    BaseFetchOptions;

export const useCreateTicketFileAccessLinkDataWrapper = ({
    onError,
    onSuccess,
}: Omit<FetchTicketsDataWrapperProps, 'children'>) => {
    const [{ data, loading, errors, resetData }, handleCreateTicketFileAccessLink] =
        useApiFetch<ApiResponseBody<TicketDownloadLinkResponse>>();

    const createTicketFileAccessLinkCall = (ticketFileId: string) => {
        return handleCreateTicketFileAccessLink(
            ticketService.createTicketFileAccessLink(ticketFileId),
            {
                useDefaultErrorHandler: true,
                onFail: onError,
                onSuccess,
            }
        );
    };

    return {
        createTicketFileAccessLink: createTicketFileAccessLinkCall,
        data,
        loading,
        errors,
        resetData,
    };
};

export const CreateTicketFileAccessLinkDataWrapper = (props: FetchTicketsDataWrapperProps) => {
    const { children } = props;
    const hookData = useCreateTicketFileAccessLinkDataWrapper(props);

    if (!children) return <></>;

    return <>{children(hookData)}</>;
};
